angular
  .module('resources.Role', ['ngResource'])
  .factory('Role', ['$resource', function ($resource) {
    var resource = $resource('/api/roles/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT'
      },
      search: {
        method: 'GET',
        url: '/api/roles-search',
        isArray: true
      }
    });

    return resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Role.js